import React from 'react'
import PropTypes from 'prop-types'
import Location from './Location'
import SexualOrientation from './SexualOrientation'

const EXTRA_SMALL_TEXT = { text: 'text-xs uppercase', container: 'mb-1.5 mr-2.5 lg:mr-3.5' }

const EventTags = ({ location, tagsByType }) => (
  <div className="flex flex-wrap overflow-x-auto">
    <Location text={location} classNames={EXTRA_SMALL_TEXT} />
    {tagsByType.sexual_orientation?.map(({ id, name }) => (
      <SexualOrientation key={id} id={id} text={name} classNames={EXTRA_SMALL_TEXT} />
    ))}
  </div>
)

EventTags.propTypes = {
  location: PropTypes.string,
  tagsByType: PropTypes.shape({
    age_group: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      })
    ),
    sexual_orientation: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      })
    ),
  }),
}

export default EventTags
